module.exports = __webpack_public_path__ + "static/media/Avenir-BlackOblique.b611d52a.woff";